/* LUVF mega menu behaviour - 19 Aug 2026.

   Turns Dawn's nested details markup into one full-width panel, without
   editing sections/header.liquid (Dawn's file, 50KB, and every edit to it
   would have to be redone on a theme update).

   What it does:
     1. finds any top-level menu item whose dropdown contains further
        dropdowns, and marks it .luvf-mega
     2. forces those inner dropdowns permanently open and marks them .luvf-col
        so CSS can lay them out as columns
     3. makes a column heading a link to its own category page instead of a
        toggle (clicking "Sides" goes to the Sides section of the menu page)
     4. clones the featured-dish card from #luvf-mega-feature into the
        THIS WEEK'S MENU panel only
     5. keeps --lmg-top in sync with the real header height so the panel
        always hangs off the bottom of the header, sticky or not

   NOTE: Dawn wraps each top-level <details> in a <header-menu> custom
   element, so the top item is li > header-menu > details, NOT li > details.
   Querying by direct child silently found nothing. Walk from the li instead.

   NOTE: hover open/close lives in luvf-motion.js, and it must only ever
   wire the TOP-LEVEL menus. The columns this file creates are <details>
   too, and wiring them makes the panel close itself the moment the pointer
   moves into it. See the long comment in luvf-motion.js.

   19 Aug 2026: the nav became three panels - Meal Plans, This Week's Menu
   and Shop. The featured-dish card is about this week's food, so it now
   goes into the menu panel only, identified by its links pointing at
   /pages/menu. Meal Plans points at /pages/meal-plans and Shop at
   /pages/shop, neither of which matches.
*/
(function () {
  var header = document.querySelector('.header-wrapper') || document.querySelector('.section-header') || document.querySelector('header');

  function syncTop() {
    if (!header) return;
    var r = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--lmg-top', Math.max(0, Math.round(r.bottom)) + 'px');
  }

  function build() {
    var items = document.querySelectorAll('.header__inline-menu > ul > li');
    var tpl = document.getElementById('luvf-mega-feature');

    items.forEach(function (li) {
      var top = li.querySelector('details');
      if (!top) return;

      var panel = top.querySelector('.header__submenu');
      if (!panel || panel.parentElement !== top) return;

      var cols = [];
      Array.prototype.forEach.call(panel.children, function (row) {
        var d = row.querySelector('details');
        if (d) cols.push(d);
      });
      if (!cols.length) return; /* flat dropdown - leave Dawn alone */

      top.classList.add('luvf-mega');

      cols.forEach(function (col) {
        col.classList.add('luvf-col');
        col.open = true;

        var sum = col.querySelector('summary');
        if (!sum || sum.dataset.luvfWired) return;
        sum.dataset.luvfWired = '1';

        /* the heading must not collapse its own column */
        sum.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var first = col.querySelector('ul a[href]');
          var href = sum.dataset.luvfHref || (first && first.getAttribute('href'));
          if (href) window.location.href = href;
        });

        /* belt and braces: something else may still try to close it */
        col.addEventListener('toggle', function () {
          if (!col.open) col.open = true;
        });
      });

      /* the featured dish belongs to this week's menu, not to plans or shop */
      var isMenuPanel = !!panel.querySelector('a[href*="/pages/menu"]');
      if (tpl && isMenuPanel && !panel.querySelector('.luvf-mega__feature')) {
        var cell = document.createElement('li');
        cell.appendChild(tpl.content.cloneNode(true));
        panel.appendChild(cell);
      }
    });

    syncTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }

  window.addEventListener('resize', syncTop, { passive: true });
  window.addEventListener('scroll', syncTop, { passive: true });
})();